import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule,MatButtonModule, MatPaginatorModule } from '@angular/material';

@NgModule({
  imports: [MatButtonModule,
    MatTableModule,
    MatPaginatorModule ], // 先import
  exports: [MatButtonModule,
    MatTableModule,
    MatPaginatorModule ] // 在export
})
export class SharedMaterialModule {}